import axios from "axios";
import { ENDPOINTS } from "./_config";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers["Accept"] = "application/json";

let isRefreshing = false;
let failedRequestsQueue = [];

// Function to refresh token
const refreshToken = async () => {

  const isSession = sessionStorage.getItem("authToken");
  let token = sessionStorage.getItem('authToken') || localStorage.getItem('authToken');
  let refreshToken = sessionStorage.getItem('refreshToken') || localStorage.getItem('refreshToken');

  try {

    if (!refreshToken) {
      throw new Error("No refresh token available");
    }

    const response = await axios.post(ENDPOINTS.AUTH.REFRESH_TOKEN, { token, refreshToken });

    if (response?.data?.token) {
      if (isSession) {
        sessionStorage.setItem('authToken', response.data.token);
        sessionStorage.setItem("refreshToken", response.data.refreshToken);
      } else {
        localStorage.setItem("authToken", response.data.token);
        localStorage.setItem("refreshToken", response.data.refreshToken);
      }

      return response.data.token;
    } else {
      throw new Error("Failed to refresh token");
    }
  } catch (error) {
    console.error("Refresh token failed:", error);
    localStorage.removeItem("authToken");
    localStorage.removeItem("refreshToken");
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/login"; // Redirect user to login if refresh fails
    return null;
  }
};

// Request Interceptor
axios.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("authToken") || localStorage.getItem("authToken");
    if (token && config?.skipAuth !== true) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedRequestsQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = `Bearer ${token}`;
            return axios(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const newToken = await refreshToken();
        if (!newToken) return Promise.reject(error);

        failedRequestsQueue.forEach((req) => req.resolve(newToken));
        failedRequestsQueue = [];

        originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
        return axios(originalRequest);
      } catch (err) {
        failedRequestsQueue.forEach((req) => req.reject(err));
        failedRequestsQueue = [];
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default axios;
